import './Auth.scss';
import { ReactElement } from 'react';
import { AuthContainer } from '../../modules/auth/containers/AuthContainer';
import { BrowserCompatibilityContainer } from '../../modules/auth/containers/BrowserCompatibilityContainer';
import { LoginContainer } from '../../modules/auth/containers/LoginContainer';

export const LoginView = (): ReactElement => (
  <AuthContainer>
    <BrowserCompatibilityContainer />
    <LoginContainer />
  </AuthContainer>
);
